import { SealPercent } from '@phosphor-icons/react'
import React from 'react'
import { useDiscountForm } from '../hooks/useDiscountForm'
import { Icon } from '@shopflo/ui'
import { useSectionInteraction } from 'src/components/common/context/SectionInteractionContext'
import { useLocale } from 'src/lib/hooks/useLocal'
import { getMethodTitle, getSummaryItems } from './discountSummaryHelpers'

const DiscountSummaryCard = () => {
  const { state } = useDiscountForm()
  const { t } = useLocale()
  const { scrollTo } = useSectionInteraction()

  const summaryItems = getSummaryItems(state, t)

  return (
    <div className=' min-w-[300px] xl:min-w-[340px] ml-auto sticky top-10'>
      <div
        className=' rounded-2xl overflow-hidden  bg-white '
        style={{
          boxShadow:
            '0 0 0 1px rgba(255, 255, 255, 0.60) inset, 0 0 0 1px rgba(10, 13, 18, 0.05), 0 1px 2px 0 rgba(10, 13, 18, 0.05)'
        }}
      >
        <div
          className='flex flex-col gap-1 px-6 pb-5 pt-6 border-b-1 border-black/5'
          style={{
            background:
              'conic-gradient(from 199deg at 89.96% 100%, rgba(255, 255, 255, 0.00) 0deg, rgba(255, 255, 255, 0.40) 44.19deg, rgba(255, 214, 126, 0.40) 84.81deg, rgba(235, 228, 240, 0.40) 130.07deg, rgba(253, 165, 213, 0.40) 158.19deg, rgba(255, 240, 133, 0.00) 360deg), #FFF'
          }}
        >
          <div
            className='flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity'
            onClick={() => scrollTo('discount-method-input')}
          >
            <Icon IconComponent={SealPercent} size='xs' iconProps={{ weight: 'fill' }} className='text-zinc-500' />
            <h3 className='text-text-sm-semibold text-zinc-700 truncate hover:underline hover:underline-offset-2'>
              {getMethodTitle(state, t) || '--'}
            </h3>
          </div>
        </div>

        <div className='px-6 pt-5 pb-6 flex flex-col gap-2 bg-white'>
          <ul className='flex flex-col gap-2'>
            {summaryItems.map((text, i) => (
              <li
                key={i}
                className='flex items-center gap-2 group cursor-pointer hover:underline hover:underline-offset-2'
                onClick={() => {
                  const sectionMap = [
                    'discount-rules',
                    'discount-rules',
                    'customer-eligibility',
                    'usage-limits',
                    'visibility-selector',
                    'discount-combination',
                    'availability-dates',
                    'channel-selector'
                  ]
                  scrollTo(sectionMap[i])
                }}
              >
                <div className='w-1 h-1 rounded-full bg-zinc-400 transition-all'></div>
                <span className='text-text-xs-medium text-zinc-600 transition-colors'>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default DiscountSummaryCard
